
import React from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw } from "lucide-react";

interface FolderErrorStateProps {
  error: string | null;
  onRetry: () => void;
}

export const FolderErrorState: React.FC<FolderErrorStateProps> = ({
  error,
  onRetry
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-8 text-center">
      <div className="bg-red-50 rounded-full p-3 mb-4">
        <AlertTriangle className="h-6 w-6 text-red-400" />
      </div>
      
      <h3 className="text-base font-medium mb-2 text-slate-800">Kunde inte ladda mappinnehåll</h3>
      
      <p className="text-sm text-slate-600 max-w-md mb-4">
        {error || "Ett oväntat fel uppstod när mappinnehållet skulle hämtas."}
      </p>
      
      <Button 
        variant="default" 
        onClick={onRetry}
        className="text-xs h-8"
      >
        <RefreshCw className="h-3.5 w-3.5 mr-1.5" />
        Försök igen
      </Button>
    </div>
  );
};
